import React from 'react';
import styles from '../pages/zogeregeld/index.module.css';
import BackgroundImage from '../assets/images/zogeregeld/greyheader.png';
import {Button, Link} from '@toppy-webshop/toppy-design-system';
import {FallbackProps} from 'react-error-boundary/dist/declarations/src/types';

const ErrorPage = ({error, resetErrorBoundary}: FallbackProps) => {
    return (
        <div
            className={styles.container}
            style={{
                backgroundImage: `linear-gradient(0deg, white 0%, transparent 10%), url(${BackgroundImage})`,
            }}
        >
            <div className={styles.wrapper}>
                <div className={styles.errorMessage}>
                    <div className={styles.errorTitle}>Oepsy!</div>
                    <div className={styles.errorDescription}>
                        Er is helaas iets niet helemaal goed gegaan, excuses
                        hiervoor. Je kunt op "opnieuw" proberen klikken om het
                        nog eens te proberen. Blijf je tegen dit probleem
                        aanlopen? Neem dan contact op met onze{' '}
                        <Link href={'/klantenservice'}>Klantenservice</Link>.
                    </div>
                    <Button
                        type={'primary'}
                        label={'Opnieuw proberen'}
                        onClick={resetErrorBoundary}
                    />
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
